import { DataBean } from "../DataBean";

export class PriceList extends DataBean {


    public async getPriceListCatalog(year: any, regexStr: any, isActive: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPriceListCatalog_Number_String_Boolean_Number_Number", [year, regexStr, isActive, page, recordsPerPage]);
    }







}